import {request} from "../shared/httpInterceptor";
import {useQuery} from "@tanstack/react-query";
import {IProductOption} from "../interfaces/iProductOption";
import {useCountryLang} from "./useCountryLang";

const fetchSetupOptions = async (productId: number, categoryId: number, countryLang: string | null) => {
  const res = await request({
    url: `/${countryLang}/productCatSetupOptions/${categoryId}/${productId}`,
    method: 'GET'
  });
  return res.data;
};

export const useSetupOptions = (productId: number, categoryId: number, showSetupOptions: boolean) => {
  const countryLang = useCountryLang();

  return useQuery<IProductOption[]>(
    ["product-setup-options", productId, countryLang],
    () => fetchSetupOptions(productId, categoryId, countryLang),
    {
      enabled: showSetupOptions && countryLang != null && productId != undefined && categoryId != undefined,
    })
}
